import { UserIcon } from "components/UserIcon/UserIcon";
import { IUserStatusViewModel } from "interfaces/models/IUserStatusViewModel";
import { Row, Col } from "react-bootstrap";

const UsernameTemplate = ({ isFederatedUser, isPortalAdmin, username }: IUserStatusViewModel) => (
  <>
    <Row className="align-items-center">
      <Col xs={2} className="d-flex justify-content-center">
        <UserIcon isFederatedUser={isFederatedUser!} isPortalAdminUser={isPortalAdmin!} />
      </Col>
      <Col xs={8}>
        <span data-testid="username" className="title">{username}</span>
      </Col>
    </Row>
  </>
);

export default UsernameTemplate;
